import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"
import { countedCopy } from "src/main/Billing/PayInvoices/copy"

import { getLedger } from "src/api/Billing/Ledgers"

import InvoiceBalanceCard from "./InvoiceBalanceCard"

export const ledgerQueryKey = ({ marinaSlug, ledgerId }) => [
  "ledger",
  marinaSlug,
  ledgerId,
]

const InvoiceBalances = ({ initialLedgerData, copy }) => {
  const { marinaSlug, presentmentCurrency } = useMarina()

  const { data: ledgerData } = useQuery(
    ledgerQueryKey({ marinaSlug, ledgerId: initialLedgerData.id }),
    () => getLedger({ marinaSlug, ledgerId: initialLedgerData.id }),
    {
      initialData: initialLedgerData,
      refetchOnMount: false,
    }
  )

  const { overdue, totalBalance, totalSpent, totalSpentDetail } = copy.balances

  return (
    <div
      data-testid="invoice-balances"
      className="flex flex-col space-y-3 md:flex-row md:space-x-3 md:space-y-0"
    >
      <InvoiceBalanceCard
        title={overdue.title}
        info={overdue.info}
        amountInCents={ledgerData.overdueBalance}
        detail={countedCopy(copy.invoiceCount, ledgerData.overdueInvoiceCount)}
        currency={presentmentCurrency}
        isAlert={ledgerData.overdueBalance > 0}
      />
      <InvoiceBalanceCard
        title={totalBalance.title}
        info={totalBalance.info}
        amountInCents={ledgerData.totalBalance}
        detail={countedCopy(
          copy.invoiceCount,
          ledgerData.unsettledInvoiceCount
        )}
        currency={presentmentCurrency}
      />
      <InvoiceBalanceCard
        title={totalSpent.title}
        info={totalSpent.info}
        amountInCents={ledgerData.totalSpent}
        detail={totalSpentDetail}
        currency={presentmentCurrency}
      />
    </div>
  )
}

const cardCopy = PropTypes.shape({
  info: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

InvoiceBalances.propTypes = {
  initialLedgerData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    totalBalance: PropTypes.number.isRequired,
    overdueBalance: PropTypes.number.isRequired,
    totalSpent: PropTypes.number.isRequired,
    overdueInvoiceCount: PropTypes.number.isRequired,
    unsettledInvoiceCount: PropTypes.number.isRequired,
  }).isRequired,
  copy: PropTypes.shape({
    balances: PropTypes.shape({
      overdue: cardCopy.isRequired,
      totalBalance: cardCopy.isRequired,
      totalSpent: cardCopy.isRequired,
      totalSpentDetail: PropTypes.string.isRequired,
    }).isRequired,
    invoiceCount: PropTypes.shape({
      one: PropTypes.string.isRequired,
      other: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default InvoiceBalances
